import { screenLoader } from '@helpers';

export const routesConfig = [
  {
    path: '/',
    component: screenLoader('home'),
    exact: true,
  },
];
